export const notificationMixins = {
	computed: {
		unreadNotificationCount() {
			return this.$store.getters.getUnreadNotificationCount;
		}
	}
}